import React, { FC } from 'react';
import classNames from 'classnames';

export interface CardHeaderProps {
  className?: string;
}

export const CardHeader: FC<CardHeaderProps> = ({ className, children }) => {
  return <div className={classNames('card__header', className)}>{children}</div>;
};
